<div class="page-title animatedBackground">
    <div class="container">
        <h3>About Us</h3>
        <ul>
            <li><a router="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>About Us</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>



<section class="about-area ptb-100 bg-fbf9f8">
    <div class="container">
       
        <div class="row  align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="features-text">
                    <h3>About OSIT</h3>
                   <p>Open Software Information Technology (OSIT) puts together a bunch of passionate minds to transform your visions into reality imparting an awesome digital experience for your users. From website design, development, scalable mobile apps, ERP Implementation, to SaaS platforms, the solution we engineer accelerate efficiency and fuel growth for our clients.</p>
            <p>&nbsp;<br></p>
                   <p>From 2012, we are committed to achieving and pushing the level of performance at all times. Leveraging the power of technology, we deliver end-to-end solutions for multi-million Riyal funded start-ups to small and medium enterprises. Our office presence at Riyadh is a true reflection.</p>
                </div>
            </div>
            
            <div class="col-lg-6 col-md-6">
                <div class="img mb-0">
                    <img style="border-radius:25px;" src="assets/img/about_us.png" alt="image">
                </div>
            </div>
        </div>
        <div class="about-inner-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="row about-image">
                        <div class="col-6 col-lg-6 col-md-6">
                            <div class="image">
                                <img src="assets/img/home2.jpg" alt="about">
                            </div>
                        </div>
                        <div class="col-6 col-lg-6 col-md-6">
                            <div class="image">
                                <img src="assets/img/home1.jpg" alt="about">
                            </div>
                        </div>
                        <div class="col-6 col-lg-6 col-md-6">
                            <div class="image mt-30">
                                <img src="assets/img/home3.jpg" alt="about">
                            </div>
                        </div>
                        <div class="col-6 col-lg-6 col-md-6">
                            <div class="image mt-30">
                                <img src="assets/img/home4.jpg" alt="about">
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-6 col-md-12">
                    <div class="about-text">
                        <span>Saudi Technology Innovation Company</span>
                        <h3>WHY OSIT ?</h3>
                        <ul style="font-style:italic">
                         <li>   We analyze, develop and implement business solutions related to the technologies that help global companies to focus on their business.<br>&nbsp;<br></li>


                           <li> Time and cost-effective customized applications that help organizations address functional gaps and achieve business goals effectively business value.<br>&nbsp;<br></li>
                            
                            
                         <li>   Our goal is to provide quality software in all aspects of the life cycle of the development from initial contact till post-development support.</li>   
                        </ul>
                            <a routerLink="/about" class="read-more-btn">View More About us.</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="rocket animate__animated animate__fadeInUp wow slow"><img src="assets/img/2030.png" alt="rocket"></div>
    <div class="vector"><img src="assets/img/vector-bg.png" alt="vector"></div>
    <div class="circle-pattern-2"></div>
</section>


<section class="funfacts-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-6 col-lg-3 col-sm-3 col-md-3">
                <div class="fun-fact">
                    <i class="icofont-users-alt-5"></i>
                    <p>Active Clients:</p>
                    <h3><span class="odometer" data-count="200">00</span><span class="sign">+</span></h3>
                </div>
            </div>
            
            <div class="col-6 col-lg-3 col-sm-3 col-md-3">
                <div class="fun-fact">
                    <i class="icofont-rocket-alt-2"></i>
                    <p>Success Rate:</p>
                    <h3><span class="odometer" data-count="91">00</span><span class="sign">%</span></h3>
                </div>
            </div>
            
            <div class="col-6 col-lg-3 col-sm-3 col-md-3">
                <div class="fun-fact">
                    <i class="icofont-laptop-alt"></i>
                    <p>Projects Done:</p>
                    <h3><span class="odometer" data-count="550">00</span><span class="sign">+</span></h3>
                </div>
            </div>
            
            <div class="col-6 col-lg-3 col-sm-3 col-md-3">
                <div class="fun-fact">
                    <i class="icofont-award"></i>
                    <p>Awards:</p>
                    <h3><span class="odometer" data-count="14">00</span><span class="sign">+</span></h3>
                </div>
            </div>
        </div>
    </div>
</section>
